import {createChannelTrackingMiddleware} from 'src/shared/channelTracking/middleware';

export const channelTracking = createChannelTrackingMiddleware();
